import { graphql } from '../graphql';

/**
 * A paired Compare surfaces submit (spec §4.3): both halves start together
 * under one analysis group. A part that failed to start comes back in
 * `failedToStart` (with a null batch id) while the other carries on. A part
 * whose start is unknown (the invoke threw ambiguously) keeps its batch id and
 * is listed in `startUncertain`: preprocess records its real outcome.
 */
export const startComparison = graphql(`
  mutation StartComparison($input: StartComparisonInput!) {
    startComparison(input: $input) {
      groupId
      deviationBatchId
      surfaceDifferenceBatchId
      reportBatchId
      failedToStart {
        part
        message
      }
      startUncertain
    }
  }
`);

/**
 * The status of a batch whose preprocess start was uncertain
 * (`startUncertain`). Its preprocess may fail before inserting any job, which
 * no job list can show; the FAILED batch is the only trace (R10).
 */
export const comparisonBatchStatusQuery = graphql(`
  query ComparisonBatchStatus($id: ID!) {
    batch(id: $id) {
      id
      status
    }
  }
`);
